import "bootstrap";
import "../scss/app.scss";
import "./swiper-init.js";
import "./justified.js";
import "./lightbox-swiper.js";
// Font Awesome (SVG Core) - JS
import { library, dom, config } from "@fortawesome/fontawesome-svg-core";
import {
  faBars,
  faXmark,
  faChevronLeft,
  faChevronRight,
  faCircle,
  faCircleInfo,
} from "@fortawesome/free-solid-svg-icons";
import { faLinkedinIn, faInstagram } from "@fortawesome/free-brands-svg-icons";

// Option: nester les SVG pour faciliter les interactions (équivalent data-auto-replace-svg="nest")
config.autoReplaceSvg = "nest";
library.add(
  faBars,
  faXmark,
  faChevronLeft,
  faChevronRight,
  faCircle,
  faCircleInfo,
  faLinkedinIn,
  faInstagram
);
dom.watch();
import "./bs-cf7-script.js";

// Bootstrap color mode toggler (light/dark)
(() => {
  const getStoredTheme = () => localStorage.getItem("theme");
  const setStoredTheme = (theme) => localStorage.setItem("theme", theme);
  const getPreferredTheme = () =>
    getStoredTheme() ||
    (window.matchMedia("(prefers-color-scheme: dark)").matches
      ? "dark"
      : "light");
  const setTheme = (theme) => {
    if (theme === "auto") {
      document.documentElement.setAttribute(
        "data-bs-theme",
        window.matchMedia("(prefers-color-scheme: dark)").matches
          ? "dark"
          : "light"
      );
    } else {
      document.documentElement.setAttribute("data-bs-theme", theme);
    }
  };
  const currentAttr = document.documentElement.getAttribute("data-bs-theme");
  setTheme(currentAttr || getPreferredTheme());
  window
    .matchMedia("(prefers-color-scheme: dark)")
    .addEventListener("change", () => {
      const stored = getStoredTheme();
      if (stored !== "light" && stored !== "dark")
        setTheme(getPreferredTheme());
    });
  document.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-bs-theme-value]");
    if (!btn) return;
    const theme = btn.getAttribute("data-bs-theme-value");
    setStoredTheme(theme);
    setTheme(theme);
  });
})();

// Lazyload via l'intersection observer (fallback léger)
const lazyImages = document.querySelectorAll(
  'img[loading="lazy"], img[data-src]'
);
if ("IntersectionObserver" in window) {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const img = entry.target;
        const dataSrc = img.getAttribute("data-src");
        if (dataSrc) {
          img.src = dataSrc;
          img.removeAttribute("data-src");
        }
        observer.unobserve(img);
      }
    });
  });
  lazyImages.forEach((img) => observer.observe(img));
}
